(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["accordion"] && !Shopify.designMode) return;
  try {
    // Toggles aria-expanded on click; the CSS above does the actual
  // expand/collapse (grid-template-rows 0fr/1fr keyed off that attribute) —
  // see sections/footer.liquid's mobile accordion for the same pattern.
  document.querySelectorAll('[data-accordion-toggle]').forEach((toggle) => {
    toggle.addEventListener('click', () => {
      const expanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!expanded));
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-notification"] && !Shopify.designMode) return;
  try {
    (function () {
    var AUTO_DISMISS_MS = 5000;

    class CartNotification extends HTMLElement {
      connectedCallback() {
        this.panel = this.querySelector('.cart-notification__panel');
        this.closeButton = this.querySelector('[data-cart-notification-close]');
        this.imageEl = this.querySelector('[data-cart-notification-image]');
        this.titleEl = this.querySelector('[data-cart-notification-title]');
        this.variantEl = this.querySelector('[data-cart-notification-variant]');
        this.quantityEl = this.querySelector('[data-cart-notification-quantity]');
        this.priceEl = this.querySelector('[data-cart-notification-price]');
        this._hideTimer = null;

        this.closeButton.addEventListener('click', this.hide.bind(this));
        this.panel.addEventListener('mouseenter', this._clearTimer.bind(this));
        this.panel.addEventListener('mouseleave', this._scheduleHide.bind(this));
        this.panel.addEventListener('focusin', this._clearTimer.bind(this));
        this.panel.addEventListener('focusout', this._scheduleHide.bind(this));

        document.addEventListener('keydown', this._onKeydown.bind(this));
        document.addEventListener('click', this._onDocumentClick.bind(this));

        // The single source of "an item was just added" — see this file's
        // own doc comment and assets/cart.js's addItem() for why this is
        // `cart:added`, not the generic `cart:updated`.
        document.addEventListener('cart:added', this._onAdded.bind(this));
      }

      _onAdded(event) {
        var item = event.detail && event.detail.item;
        if (!item) return;
        this._render(item);
        this.show();
      }

      _render(item) {
        this.titleEl.textContent = item.product_title || item.title || '';

        if (item.variant_title) {
          this.variantEl.textContent = item.variant_title;
          this.variantEl.hidden = false;
        } else {
          this.variantEl.textContent = '';
          this.variantEl.hidden = true;
        }

        this.quantityEl.textContent = item.quantity > 1 ? item.quantity + ' ×' : '';

        this.priceEl.textContent = this._formatMoney(item.final_price != null ? item.final_price : item.price);

        this.imageEl.innerHTML = '';
        if (item.image) {
          var img = document.createElement('img');
          var src = item.image;
          src += (src.indexOf('?') === -1 ? '?' : '&') + 'width=160';
          img.src = src;
          img.alt = item.product_title || item.title || '';
          img.width = 64;
          img.height = 64;
          img.loading = 'lazy';
          this.imageEl.appendChild(img);
        }
      }

      _formatMoney(cents) {
        if (typeof cents !== 'number') return '';
        var currency = this.dataset.currency || 'USD';
        try {
          return new Intl.NumberFormat(document.documentElement.lang || undefined, {
            style: 'currency',
            currency: currency,
          }).format(cents / 100);
        } catch (error) {
          return (cents / 100).toFixed(2);
        }
      }

      show() {
        this.classList.add('is-visible');
        this._scheduleHide();
      }

      hide() {
        this.classList.remove('is-visible');
        this._clearTimer();
      }

      _scheduleHide() {
        this._clearTimer();
        this._hideTimer = window.setTimeout(this.hide.bind(this), AUTO_DISMISS_MS);
      }

      _clearTimer() {
        if (this._hideTimer) {
          window.clearTimeout(this._hideTimer);
          this._hideTimer = null;
        }
      }

      _onKeydown(event) {
        if (event.key === 'Escape' && this.classList.contains('is-visible')) this.hide();
      }

      _onDocumentClick(event) {
        if (!this.classList.contains('is-visible')) return;
        if (this.contains(event.target)) return;
        this.hide();
      }
    }

    if (!customElements.get('cart-notification')) {
      customElements.define('cart-notification', CartNotification);
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["help-modal"] && !Shopify.designMode) return;
  try {
    // One delegated listener covers every `help-modal` instance on the page —
  // opening is just `showModal()` on the matching `<dialog>` (native
  // focus-trap included for free); closing is deliberately NOT a bare
  // `.close()` — see this file's top comment on why every close path
  // (✕ button, backdrop click, Escape) instead plays the `.is-closing`
  // exit animation first and lets `animationend` call the real `.close()`.
  (function () {
    var GAP = 8; // space kept between the trigger and the popover, and between the popover and the viewport edge

    function requestClose(dialog) {
      if (!dialog || dialog.classList.contains('is-closing')) return;
      dialog.classList.add('is-closing');
    }

    // Anchors the "popover" variant to the trigger that opened it — read
    // AFTER `showModal()` so `dialog.getBoundingClientRect()` reflects its
    // real rendered size (a closed `<dialog>` is `display: none` and
    // measures 0×0). Written synchronously in the same click handler,
    // before the browser's next paint — see this rule's own CSS comment
    // on why the `top: 0; left: 0` CSS default is never actually visible.
    function positionPopover(dialog, trigger) {
      if (dialog.dataset.variant !== 'popover' || !trigger) return;

      var triggerRect = trigger.getBoundingClientRect();
      var dialogRect = dialog.getBoundingClientRect();
      var viewportWidth = document.documentElement.clientWidth;
      var viewportHeight = document.documentElement.clientHeight;

      // Prefer directly below the trigger, flipped above it if there's
      // not enough room below.
      var top = triggerRect.bottom + GAP;
      if (top + dialogRect.height > viewportHeight - GAP) {
        top = triggerRect.top - dialogRect.height - GAP;
      }
      top = Math.max(GAP, Math.min(top, viewportHeight - dialogRect.height - GAP));

      // Left-aligned with the trigger, clamped so it never overflows
      // either viewport edge.
      var left = triggerRect.left;
      var maxLeft = viewportWidth - dialogRect.width - GAP;
      left = Math.max(GAP, Math.min(left, maxLeft));

      dialog.style.top = top + 'px';
      dialog.style.left = left + 'px';
    }

    document.addEventListener('click', function (event) {
      var opener = event.target.closest('[data-help-modal-open]');
      if (opener) {
        var dialog = document.getElementById('help-modal-' + opener.dataset.helpModalOpen);
        if (dialog && typeof dialog.showModal === 'function') {
          dialog.classList.remove('is-closing');
          dialog.showModal();
          positionPopover(dialog, opener);
        }
        return;
      }

      var closer = event.target.closest('[data-help-modal-close]');
      if (closer) {
        requestClose(closer.closest('[data-help-modal]'));
        return;
      }

      // Click on the ::backdrop lands directly on the <dialog> element
      // itself (it has no other box there) — close only in that exact
      // case, not for a click that bubbled up from inside .help-modal__panel.
      var dialogEl = event.target.closest('[data-help-modal]');
      if (dialogEl && event.target === dialogEl) requestClose(dialogEl);
    });

    // Escape fires 'cancel' on the <dialog> and, by default, closes it
    // immediately (skipping any exit animation) right after — 'cancel'
    // doesn't bubble, so this has to be a CAPTURING document listener to
    // still see it. preventDefault() stops that immediate native close so
    // requestClose()'s animated path runs instead.
    document.addEventListener(
      'cancel',
      function (event) {
        if (!event.target.matches || !event.target.matches('[data-help-modal]')) return;
        event.preventDefault();
        requestClose(event.target);
      },
      true,
    );

    // Fires once the `.is-closing` exit animation (popover or sheet, see
    // the stylesheet above) finishes — only then is the dialog actually
    // removed from the top layer.
    document.addEventListener('animationend', function (event) {
      var dialogEl = event.target;
      if (!dialogEl.matches || !dialogEl.matches('[data-help-modal].is-closing')) return;
      dialogEl.classList.remove('is-closing');
      dialogEl.close();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mobile-nav"] && !Shopify.designMode) return;
  try {
    // Motion's usual `import { animate } from '...'` is a MODULE-level
  // statement — but Shopify's javascript-tag bundling produces a classic
  // (non-module) script, and a top-level `import` there throws a
  // SyntaxError that kills parsing for the WHOLE bundle: every section's
  // JS on the page, not just this file, silently stops working. A dynamic
  // import() is just a function call (valid anywhere) that still loads
  // Motion as a real ES module under the hood. Kicked off here at module
  // scope, not inside open(), so the fetch is already in flight before the
  // customer ever taps the hamburger. Don't "simplify" this back to a
  // static import — see AGENTS.md § Mobile navigation, this cost a full
  // page of broken JS to find once already.
  const motionPromise = import('https://cdn.jsdelivr.net/npm/motion@11/+esm');

  // The theme's motion tokens (Theme settings > Motion) are the single
  // source of truth for every transition's timing — see AGENTS.md § Design
  // tokens. Reading them at runtime via getComputedStyle, instead of
  // hardcoding a duration/easing here, means a merchant tuning
  // `motion_duration_base`/`motion_ease` tunes this drawer too, same as
  // every CSS transition elsewhere in the theme.
  function readDuration(cssVar, fallbackSeconds) {
    const raw = getComputedStyle(document.documentElement).getPropertyValue(cssVar).trim();
    if (raw.endsWith('ms')) return parseFloat(raw) / 1000;
    if (raw.endsWith('s')) return parseFloat(raw);
    return fallbackSeconds;
  }

  function readEasing(cssVar, fallback) {
    const raw = getComputedStyle(document.documentElement).getPropertyValue(cssVar).trim();
    const match = raw.match(/cubic-bezier\(([^)]+)\)/);
    if (!match) return fallback;
    const values = match[1].split(',').map((n) => parseFloat(n.trim()));
    return values.length === 4 ? values : fallback;
  }

  class MobileNav extends HTMLElement {
    connectedCallback() {
      this.toggle = this.querySelector('.mobile-nav__toggle');
      this.panel = this.querySelector('.mobile-nav__panel');
      this.closeButton = this.querySelector('.mobile-nav__close');
      this.list = this.querySelector('.mobile-nav__menu');

      this.toggle.addEventListener('click', () => this.open());
      this.closeButton.addEventListener('click', () => this.close());
      this.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') this.close();
      });

      this.list.addEventListener('click', (event) => {
        const submenuToggle = event.target.closest('.mobile-nav__submenu-toggle');
        if (!submenuToggle) return;

        const item = submenuToggle.closest('.mobile-nav__item');
        const isOpen = item.classList.toggle('is-open');
        submenuToggle.setAttribute('aria-expanded', String(isOpen));
      });
    }

    get isOpen() {
      return !this.panel.hidden;
    }

    // Falls back to a plain CSS transition (no Motion) if the CDN fetch
    // ever fails — a flaky third-party network shouldn't be able to trap a
    // customer behind a nav drawer stuck off-screen.
    //
    // The returned promise resolves off a plain `setTimeout` matched to
    // `duration`, NOT by awaiting Motion's `animate(...).finished` (the
    // earlier implementation did that). `.finished` was found to hang
    // indefinitely in testing elsewhere in this theme — reproduced in
    // isolation, a bare `animate(el, {opacity:[0,1]}, {duration:0.2})
    // .finished` never settled — see sections/announcement-bar.liquid and
    // AGENTS.md § Announcement bar for the full writeup. Here that would
    // have meant `close()` (below) never resolving its `await`, so
    // `this.panel.hidden` never gets set back to `true` and the drawer
    // stays visually open (and untabbable-past) forever. `setTimeout`
    // doesn't depend on Motion's completion signal at all, so it can't
    // hang the same way — the CDN failure case (Motion import rejecting)
    // is still handled by the `.catch` below, just no longer via a
    // promise chain that could itself hang.
    animatePanel(fromY, toY) {
      const duration = readDuration('--dur-base', 0.2);
      const easing = readEasing('--ease-standard', 'ease-out');

      motionPromise
        .then(({ animate }) => {
          animate(this.panel, { transform: [`translateY(${fromY})`, `translateY(${toY})`] }, { duration, easing });
        })
        .catch(() => {
          this.panel.style.transition = `transform ${duration}s var(--ease-standard, ease-out)`;
          this.panel.style.transform = `translateY(${toY})`;
        });

      return new Promise((resolve) => setTimeout(resolve, duration * 1000));
    }

    async open() {
      if (this.isOpen) return;

      this.panel.hidden = false;
      this.panel.style.transform = 'translateY(100%)';
      this.toggle.setAttribute('aria-expanded', 'true');
      document.documentElement.style.overflow = 'hidden';
      this.closeButton.focus();

      this.animatePanel('100%', '0%');
    }

    async close() {
      if (!this.isOpen) return;

      this.toggle.setAttribute('aria-expanded', 'false');
      document.documentElement.style.overflow = '';

      await this.animatePanel('0%', '100%');
      this.panel.hidden = true;
      this.toggle.focus();
    }
  }

  customElements.define('mobile-nav', MobileNav);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["predictive-search"] && !Shopify.designMode) return;
  try {
    class PredictiveSearch extends HTMLElement {
    connectedCallback() {
      this.toggle = this.querySelector('.predictive-search__toggle');
      this.dialog = this.querySelector('[data-predictive-search-dialog]');
      this.input = this.querySelector('.predictive-search__input');
      this.closeButton = this.querySelector('[data-predictive-search-close]');
      this.resultsEl = this.querySelector('[data-predictive-search-results]');

      this.url = this.dataset.url;
      this.types = this.dataset.types;
      this.limit = this.dataset.limit;

      this.abortController = null;
      this.debounceTimer = null;

      this.toggle.addEventListener('click', () => this.open());
      this.closeButton.addEventListener('click', () => this.close());
      this.input.addEventListener('input', (event) => this.onInput(event));
      this.addEventListener('keydown', (event) => this.onKeydown(event));
      this.resultsEl.addEventListener('click', (event) => this.onResultsClick(event));

      // `<dialog>` fires 'close' on Escape, backdrop-adjacent form
      // submission, or our own close() call — one listener resets state for
      // all three instead of duplicating that reset at each call site.
      this.dialog.addEventListener('close', () => this.onClose());

      // Clicking the dimmed ::backdrop lands directly on the <dialog>
      // element itself (it has no other box there) — same convention as
      // snippets/help-modal.liquid's own backdrop-click-to-close.
      this.dialog.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.close();
      });
    }

    open() {
      if (this.dialog.open) return;
      this.dialog.showModal();
      this.toggle.setAttribute('aria-expanded', 'true');
      this.input.focus();
    }

    close() {
      if (!this.dialog.open) return;
      this.dialog.close();
    }

    onClose() {
      this.toggle.setAttribute('aria-expanded', 'false');
      this.input.setAttribute('aria-expanded', 'false');
      if (this.abortController) this.abortController.abort();
      window.clearTimeout(this.debounceTimer);
    }

    onResultsClick(event) {
      // Suggested search terms (predictive_search's "queries" resource) are
      // real <a href="/search?q=..."> links for no-JS/progressive-enhancement,
      // but with JS available a click should behave like typing that term:
      // fill the input and refetch the dropdown in place, not navigate away.
      const queryLink = event.target.closest('.predictive-search-results__query');
      if (!queryLink) return;

      const term = queryLink.dataset.term;
      if (!term) return;

      event.preventDefault();
      this.input.value = term;
      this.input.focus();
      window.clearTimeout(this.debounceTimer);
      this.fetchResults(term);
    }

    onInput(event) {
      const term = event.target.value.trim();
      window.clearTimeout(this.debounceTimer);

      if (term.length < 2) {
        if (this.abortController) this.abortController.abort();
        this.resultsEl.innerHTML = '';
        this.input.setAttribute('aria-expanded', 'false');
        return;
      }

      this.debounceTimer = window.setTimeout(() => this.fetchResults(term), 300);
    }

    fetchResults(term) {
      if (this.abortController) this.abortController.abort();
      this.abortController = new AbortController();

      this.resultsEl.classList.add('is-loading');

      const params = new URLSearchParams({
        q: term,
        section_id: 'predictive-search',
        'resources[type]': this.types,
        'resources[limit]': this.limit,
        'resources[options][unavailable_products]': 'last',
      });

      fetch(`${this.url}?${params.toString()}`, { signal: this.abortController.signal })
        .then((response) => {
          if (!response.ok) throw new Error(response.statusText);
          return response.text();
        })
        .then((markup) => {
          this.resultsEl.innerHTML = markup;
          this.input.setAttribute('aria-expanded', 'true');
        })
        .catch((error) => {
          if (error.name !== 'AbortError') this.resultsEl.innerHTML = '';
        })
        .finally(() => {
          this.resultsEl.classList.remove('is-loading');
        });
    }

    onKeydown(event) {
      // Escape is handled natively by <dialog> itself (fires 'close', which
      // onClose() above already resets state for) — no manual handling here.
      if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;

      const items = Array.from(this.resultsEl.querySelectorAll('[data-predictive-search-item]'));
      if (items.length === 0) return;

      event.preventDefault();
      const currentIndex = items.indexOf(document.activeElement);
      let nextIndex;

      if (event.key === 'ArrowDown') {
        nextIndex = currentIndex + 1 >= items.length ? 0 : currentIndex + 1;
      } else if (currentIndex <= 0) {
        nextIndex = items.length - 1;
      } else {
        nextIndex = currentIndex - 1;
      }

      items[nextIndex].focus();
    }
  }

  customElements.define('predictive-search', PredictiveSearch);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    // One delegated `document` listener covers every card instance on the
  // page — same dedup precedent as snippets/help-modal.liquid's own
  // top-of-file comment (Shopify compiles identical javascript-tag
  // content into a single shared bundle regardless of how many times this
  // snippet renders).
  (function () {
    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-quick-add-trigger]');
      if (!trigger) return;
      event.preventDefault();

      // Multi-variant product: no single variant to add — hand off to
      // quick-add-modal.liquid's own listener instead of touching the cart
      // directly. See this file's top comment for the full contract.
      if (trigger.hasAttribute('data-quick-add-multi')) {
        document.dispatchEvent(
          new CustomEvent('quick-add:open', { detail: { url: trigger.dataset.productUrl } }),
        );
        return;
      }

      // Single-variant product: add straight to the cart, same centralized
      // entry point every other add-to-cart control in this theme uses
      // (see AGENTS.md § Cart) — never a hand-rolled fetch here.
      var variantId = trigger.dataset.variantId;
      if (!variantId || !window.GoarCart || trigger.disabled) return;

      trigger.disabled = true;
      window.GoarCart.addItem(variantId)
        .catch(function () {
          // GoarCart already dispatched 'cart:error' — nothing extra to do.
        })
        .finally(function () {
          trigger.disabled = false;
        });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-gallery"] && !Shopify.designMode) return;
  try {
    class ProductGallery extends HTMLElement {
    connectedCallback() {
      var mainViewport = this.querySelector('.product-gallery__main-viewport');
      var slides = Array.prototype.slice.call(this.querySelectorAll('[data-gallery-slide]'));
      var thumbs = Array.prototype.slice.call(this.querySelectorAll('[data-gallery-thumb]'));
      if (!mainViewport || !slides.length) return;

      // Safe to call repeatedly with the same index — see this file's top
      // comment on the click → scroll → observer round trip this covers.
      function setActive(index) {
        thumbs.forEach(function (thumb, i) {
          var isActive = i === index;
          thumb.classList.toggle('is-active', isActive);
          if (isActive) {
            thumb.setAttribute('aria-current', 'true');
            // 'nearest' — only moves the thumbnail strip if the active
            // thumb isn't already visible in it, so this never fights a
            // user who's mid-scroll through the thumbnail row themselves.
            thumb.scrollIntoView({ behavior: 'smooth', inline: 'nearest', block: 'nearest' });
          } else {
            thumb.removeAttribute('aria-current');
          }
        });
      }

      // No thumbnails to sync (single-media product) — still wire nothing
      // up beyond native scrolling, which already works for free.
      if (thumbs.length) {
        var observer = new IntersectionObserver(
          function (entries) {
            var best = null;
            entries.forEach(function (entry) {
              if (!best || entry.intersectionRatio > best.intersectionRatio) {
                best = entry;
              }
            });
            if (best && best.intersectionRatio > 0) {
              var index = slides.indexOf(best.target);
              if (index !== -1) setActive(index);
            }
          },
          { root: mainViewport, threshold: [0, 0.25, 0.5, 0.75, 1] },
        );
        slides.forEach(function (slide) { observer.observe(slide); });

        thumbs.forEach(function (thumb, i) {
          thumb.addEventListener('click', function () {
            var slide = slides[i];
            if (slide) slide.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
          });
        });
      }
    }
  }

  if (!customElements.get('product-gallery')) {
    customElements.define('product-gallery', ProductGallery);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["quick-add-modal"] && !Shopify.designMode) return;
  try {
    (function () {
    class QuickAddModal extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('[data-quick-add-dialog]');
        this.body = this.querySelector('[data-quick-add-body]');
        this.closeButton = this.querySelector('[data-quick-add-close]');
        this.cache = {};

        this.closeButton.addEventListener('click', this._requestClose.bind(this));
        document.addEventListener('click', this._onDocumentClick.bind(this));
        document.addEventListener('cancel', this._onCancel.bind(this), true);
        this.dialog.addEventListener('animationend', this._onAnimationEnd.bind(this));
        document.addEventListener('quick-add:open', this._onOpen.bind(this));

        // Auto-close once the injected form's own add-to-cart succeeds —
        // this file never wires the form itself, it just reacts to the
        // same `cart:added` event snippets/cart-notification.liquid does
        // (see AGENTS.md § Cart). Only while this dialog is actually open,
        // so an add-to-cart elsewhere on the page can't close a modal that
        // isn't showing it.
        document.addEventListener(
          'cart:added',
          function () {
            if (this.dialog.open) this._requestClose();
          }.bind(this),
        );
      }

      _onOpen(event) {
        var url = event.detail && event.detail.url;
        if (!url) return;

        this.dialog.classList.remove('is-closing');
        this.body.innerHTML = '';
        this._setStatus(this.dataset.loadingText || 'Loading…');
        this.dialog.showModal();

        if (this.cache[url]) {
          this._render(this.cache[url]);
          return;
        }

        // A plain fetch of the real product URL, NOT `?section_id=main` —
        // see this file's top comment on why the full page (specifically
        // its `<script src>` tags) is what's actually needed here.
        fetch(url)
          .then(function (response) {
            if (!response.ok) throw new Error('Quick add fetch failed');
            return response.text();
          })
          .then(
            function (html) {
              var doc = new DOMParser().parseFromString(html, 'text/html');
              var node = doc.querySelector('.product');
              if (!node) throw new Error('Quick add: .product node not found');
              this._ensureManifestScript(doc, 'blocks-script', 'data-blocks');
              this._ensureManifestScript(doc, 'snippets-script', 'data-snippets');
              this._loadMissingScripts(doc);
              this._namespaceIds(node);
              this.cache[url] = node.outerHTML;
              this._render(this.cache[url]);
            }.bind(this),
          )
          .catch(
            function () {
              this._setError(url);
            }.bind(this),
          );
      }

      // Handles the two manifest-carrying script elements
      // (`#blocks-script`/`data-blocks` and `#snippets-script`/
      // `data-snippets`) described in this file's top comment. `elementId`
      // is BOTH the element to read off the fetched `doc` AND the element
      // to look for already on this page — they're the same tag, since the
      // bundle's own `<script>` IS the manifest element.
      //
      // No-ops (does nothing, appends nothing) when the fetched page
      // carries no such element, or when every block/snippet it names is
      // already in this page's own manifest. Otherwise re-runs the bundle
      // with the MERGED list: cloning every attribute off the fetched
      // element reproduces its real `src`, so appending it re-executes the
      // exact same bundle — the only way to pick up a newly-needed name,
      // since `__blocks__`/`__snippets__` are built once, synchronously,
      // the instant that `<script>` runs (reading this exact element back
      // via `document.getElementById(elementId)`), not kept live afterward.
      // Clearing the STALE element's own `id` first is what makes that
      // fresh run's `getElementById` call resolve to the newly-appended
      // element instead of the old one still earlier in the document (two
      // elements can't usefully share an id — `getElementById` always
      // returns whichever comes first).
      _ensureManifestScript(doc, elementId, dataAttribute) {
        var sourceEl = doc.getElementById(elementId);
        if (!sourceEl) return;

        var needed = (sourceEl.getAttribute(dataAttribute) || '').split(',').filter(Boolean);
        if (!needed.length) return;

        var current = document.getElementById(elementId);
        var currentList = current ? (current.getAttribute(dataAttribute) || '').split(',').filter(Boolean) : [];
        var missing = needed.filter(function (name) {
          return currentList.indexOf(name) === -1;
        });
        if (!missing.length) return;

        if (current) current.removeAttribute('id');

        var script = document.createElement('script');
        Array.prototype.forEach.call(sourceEl.attributes, function (attribute) {
          script.setAttribute(attribute.name, attribute.value);
        });
        script.setAttribute(dataAttribute, currentList.concat(missing).join(','));
        script.async = false;
        document.body.appendChild(script);
      }

      // Appends whatever OTHER `<script src>` tags the fetched page has
      // that THIS page doesn't (compared by URL, query string stripped —
      // a cache-busting `?v=...` differing would otherwise look like a
      // "new" script every time) — anything unrelated to the two manifest
      // elements `_ensureManifestScript` above already handled (skipped
      // here by `id` so neither is ever appended twice). `async = false`
      // on each preserves the fetched page's own script order (the
      // default for a script element created via `document.createElement`,
      // unlike one written by the HTML parser, is to execute as soon as it
      // loads — not necessarily in document order).
      _loadMissingScripts(doc) {
        function withoutQuery(src) {
          return src ? src.split('?')[0] : src;
        }
        var existing = Array.prototype.map
          .call(document.scripts, function (s) {
            return withoutQuery(s.getAttribute('src'));
          })
          .filter(Boolean);

        doc.querySelectorAll('script[src]').forEach(function (source) {
          if (source.id === 'blocks-script' || source.id === 'snippets-script') return;
          var src = source.getAttribute('src');
          if (!src || existing.indexOf(withoutQuery(src)) !== -1) return;
          var script = document.createElement('script');
          Array.prototype.forEach.call(source.attributes, function (attribute) {
            script.setAttribute(attribute.name, attribute.value);
          });
          script.async = false;
          document.body.appendChild(script);
        });
      }

      // A `block.id` (variant-picker's own pill/label/textarea ids,
      // help-modal's dialog/trigger ids, …) is deterministic off the
      // SECTION's static config in `templates/product.json` — NOT
      // randomized per product — so the fetched page's ids come back
      // byte-for-byte identical to whatever the CURRENT page's own
      // product form already uses them (confirmed live: opening a quick
      // add while browsing a different product's real PDP produced two
      // `id="help-modal-…"` dialogs sharing the exact same id).
      // `document.getElementById`-based lookups — help-modal.liquid's
      // click delegate is the one this actually breaks, since it resolves
      // its dialog that way — silently grab whichever element owns that id
      // FIRST in document order, which is never guaranteed to be the copy
      // inside this modal. Renaming every id in the fetched fragment
      // (suffixed, so it's still legible while debugging) before it ever
      // touches the real document avoids the collision entirely, on every
      // page — not only when a colliding instance happens to already be
      // present — since two DIFFERENT products opened back to back would
      // collide with each other's cached copies otherwise too.
      //
      // Exact-match `id`/`for`/`aria-labelledby`/`aria-describedby` pairs
      // (variant-pill.liquid's `label for="X"` / `input id="X"`, the
      // Requirements textarea's matching label, help-modal's own
      // `aria-labelledby` -> its title `id`) are all literally the SAME
      // string in both places, so a plain exact-match rename covers them.
      // help-modal's OWN trigger -> dialog link is the one exception: its
      // `data-help-modal-open` attribute stores the dialog's bare id
      // param, while the dialog's real `id` attribute is that same param
      // prefixed with `help-modal-` (see that file's own doc comment) —
      // never itself an element's `id`, so it's resolved separately below
      // by deriving the dialog's new bare suffix off the same rename
      // already computed for its full id.
      _namespaceIds(node) {
        var suffix = '--quick-add-' + Date.now().toString(36);
        var idMap = {};

        node.querySelectorAll('[id]').forEach(function (el) {
          idMap[el.id] = el.id + suffix;
        });

        node.querySelectorAll('[data-help-modal-open]').forEach(function (trigger) {
          var bare = trigger.dataset.helpModalOpen;
          var renamedDialogId = idMap['help-modal-' + bare];
          if (renamedDialogId) idMap[bare] = renamedDialogId.slice('help-modal-'.length);
        });

        if (!Object.keys(idMap).length) return;

        node.querySelectorAll('[id]').forEach(function (el) {
          if (idMap[el.id]) el.id = idMap[el.id];
        });

        ['for', 'aria-labelledby', 'aria-describedby', 'data-help-modal-open'].forEach(function (attributeName) {
          node.querySelectorAll('[' + attributeName + ']').forEach(function (el) {
            var value = el.getAttribute(attributeName);
            if (idMap[value]) el.setAttribute(attributeName, idMap[value]);
          });
        });
      }

      _render(html) {
        this.body.innerHTML = html;
      }

      _setStatus(text) {
        this.body.innerHTML = '<p class="quick-add-modal__status" data-quick-add-status>' + text + '</p>';
      }

      _setError(url) {
        var status = this.body.querySelector('[data-quick-add-status]');
        var message = this.dataset.errorText || 'Sorry, something went wrong loading this product.';
        var linkText = this.dataset.viewDetailsText || 'View full details';
        var html = '<p>' + message + '</p><p><a href="' + url + '">' + linkText + '</a></p>';
        if (status) {
          status.innerHTML = html;
        } else {
          this.body.innerHTML = '<div class="quick-add-modal__status" data-quick-add-status>' + html + '</div>';
        }
      }

      _requestClose() {
        if (this.dialog.classList.contains('is-closing')) return;
        this.dialog.classList.add('is-closing');
      }

      _onDocumentClick(event) {
        // Click on the ::backdrop lands directly on the <dialog> element
        // itself (it has no other box there) — same check as
        // snippets/help-modal.liquid's own backdrop handler.
        if (event.target === this.dialog) this._requestClose();
      }

      _onCancel(event) {
        if (event.target !== this.dialog) return;
        event.preventDefault();
        this._requestClose();
      }

      _onAnimationEnd(event) {
        if (event.target !== this.dialog || !this.dialog.classList.contains('is-closing')) return;
        this.dialog.classList.remove('is-closing');
        this.dialog.close();
      }
    }

    if (!customElements.get('quick-add-modal')) {
      customElements.define('quick-add-modal', QuickAddModal);
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["upsell"] && !Shopify.designMode) return;
  try {
    // Intercepts the add button's click (NOT the form's submit — see this
  // snippet's own doc comment on `no_form`: a row rendered with
  // `no_form: true` has no <form> to submit at all, only a <div>) and
  // routes it through the theme's centralized cart manager
  // (window.GoarCart, assets/cart.js) instead of a full-page POST — see
  // AGENTS.md § Cart. Only intercepts when GoarCart actually loaded;
  // otherwise a real (non-`no_form`) <form>'s action/method still carry the
  // request as a plain, fully-functional POST (progressive enhancement,
  // not a dead fallback) — calling preventDefault() on a type="submit"
  // button's click event stops that pending native submission just as
  // reliably as calling it on the form's own submit event would.
  document.querySelectorAll('[data-upsell-form]').forEach((form) => {
    if (!window.GoarCart) return;

    const button = form.querySelector('[data-upsell-add]');
    if (!button) return;

    button.addEventListener('click', (event) => {
      event.preventDefault();
      if (form.classList.contains('is-adding')) return;

      const variantId = form.querySelector('input[name="id"]').value;
      form.classList.add('is-adding');

      window.GoarCart.addItem(variantId, 1)
        .then(() => {
          // Momentary plus → checkmark → plus confirmation — see the CSS
          // comment above .upsell__add-wrap. HOLD_MS is how long the
          // checkmark stays up before fading back; the fade itself is
          // --dur-base (tunable via Theme settings > Motion), this hold is
          // this component's own timing, not a theme-wide token.
          const wrap = form.querySelector('[data-upsell-add-wrap]');
          const HOLD_MS = 1200;
          wrap.classList.add('is-added');
          setTimeout(() => wrap.classList.remove('is-added'), HOLD_MS);
        })
        .catch(() => {
          // GoarCart already dispatched 'cart:error' — nothing extra to do
          // here besides not leaving the button stuck disabled.
        })
        .finally(() => {
          form.classList.remove('is-adding');
        });
    });
  });

  // "Already in cart" bubble on the plus icon — driven entirely by
  // window.GoarCart's `cart:updated` event, never a local fetch/tally kept
  // here (see AGENTS.md § Cart). Sums quantity across every cart line for
  // that variant id, since the same variant can appear as more than one
  // line if lines carry different properties.
  document.addEventListener('cart:updated', (event) => {
    document.querySelectorAll('[data-upsell-form]').forEach((form) => {
      const variantId = Number(form.querySelector('input[name="id"]').value);
      const quantity = event.detail.cart.items
        .filter((item) => item.variant_id === variantId)
        .reduce((total, item) => total + item.quantity, 0);

      const badge = form.querySelector('[data-upsell-qty]');
      if (badge) badge.textContent = quantity > 0 ? quantity : '';
    });
  });
  } catch(e) { console.error(e); }
})();

})();
